var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.EditInstalledWorkflowConfiguration,_vm._b({on:{"close":_setup.close}},'EditInstalledWorkflowConfiguration',_setup.props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }